export default () => {
  return (
    <svg width="96" height="18" viewBox="0 0 96 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M34.1305 9.44649C34.1305 5.94883 36.9648 3.18735 40.7141 3.18735C44.4633 3.18735 47.4995 6.01651 47.1421 10.0704H36.4519C36.7646 12.142 38.5499 13.7447 40.7141 13.7447C42.5209 13.7447 43.7717 12.8534 44.4187 11.5609H46.7847C46.0484 14.0105 43.7271 15.704 40.7141 15.704C36.9863 15.704 34.1305 12.9194 34.1305 9.44484V9.44649ZM44.7992 8.51224C44.4418 6.64044 42.8121 5.14828 40.6926 5.14828C38.5731 5.14828 36.9433 6.59588 36.5181 8.51224H44.7992Z"
        fill="black"
      />
      <path
        d="M48.5683 9.44649C48.5683 5.95048 51.492 3.189 55.1519 3.189C58.5669 3.189 60.8436 5.19285 61.4012 8.04347H59.0137C58.5223 6.37304 57.1605 5.17139 55.1304 5.17139C52.7875 5.17139 50.8682 7.10922 50.8682 9.44649C50.8682 11.7838 52.7875 13.7232 55.1304 13.7232C57.2069 13.7232 58.5901 12.4539 59.06 10.7389H61.4029C60.9115 13.6572 58.5901 15.7056 55.1535 15.7056C51.4473 15.7056 48.57 12.921 48.57 9.44649H48.5683Z"
        fill="black"
      />
      <path
        d="M70.9067 9.42504C70.9067 5.95048 73.8304 3.189 77.4886 3.189C81.1469 3.189 84.0705 5.95048 84.0705 9.42504C84.0705 12.8996 81.2362 15.7056 77.4886 15.7056C73.741 15.7056 70.9067 12.921 70.9067 9.42504ZM77.4886 13.7216C79.8315 13.7216 81.7508 11.7838 81.7508 9.44484C81.7508 7.10592 79.8315 5.16974 77.4886 5.16974C75.1458 5.16974 73.2049 7.10757 73.2049 9.44484C73.2049 11.7821 75.1242 13.7216 77.4886 13.7216Z"
        fill="black"
      />
      <path
        d="M87.8297 3.51747C86.5954 3.51747 85.5927 4.5194 85.5927 5.75571V15.3772H87.8297V5.75571H93.7647V15.3772H96V5.75571C96 4.5194 94.999 3.51747 93.7647 3.51747H87.8297Z"
        fill="black"
      />
      <path
        d="M33.2271 5.82504V3.84099H29.7294V1.17854H27.3782V3.84099H24.9146V5.82504H27.3782V12.4176C27.3782 14.0286 28.6903 15.3359 30.3101 15.3359H33.7599V13.3139H29.7294V5.82339H33.2271V5.82504Z"
        fill="black"
      />
      <path
        d="M69.9206 5.82504V3.84099H66.4228V1.17854H64.0717V3.84099H61.6097V5.82504H64.0717V12.4176C64.0717 14.0286 65.3838 15.3359 67.0019 15.3359H70.4517V13.3139H66.4212V5.82339H69.919L69.9206 5.82504Z"
        fill="black"
      />
      <path d="M10.3543 18L14.2045 14.159H8.97937V18H10.3543Z" fill="#E54B24" />
      <path d="M18.0663 3.84099H14.2045V14.159L18.0663 10.3065V3.84099Z" fill="#E54B24" />
      <path d="M7.71197 0L3.86177 3.84099H9.08692V0H7.71197Z" fill="#E54B24" />
      <path d="M0 14.159H3.86177V3.84099L0 7.69354V14.159Z" fill="#E54B24" />
    </svg>
  );
};
